import { render, staticRenderFns } from "./ApplicationStepPage.vue?vue&type=template&id=031f614b&scoped=true&"
import script from "./ApplicationStepPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplicationStepPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ApplicationStepPage.vue?vue&type=style&index=0&id=031f614b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f614b",
  null
  
)

export default component.exports